/* 🤖 this file was generated by svg-to-ts */
export const iccIconDisabled: {
  name: 'disabled';
  data: string;
} = {
  name: 'disabled',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Zm-5-9h10v2H7v-2Z" fill="currentColor"/></svg>`
};
